$(document).ready(function(){
    $('.main-announcement-slider').slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false
  });

  $('.sims-lp-bottom-banner-slider').slick({
  slidesToShow: 1,
  dots:true,
  arrows:true,
  centerMode: true,
    prevArrow: '<button class="slick-prev slick-arrow"><</button>',
    nextArrow: '<button class="slick-next slick-arrow">></button>'
  });

  $('.sims-lp-icon-list-btn a').on('click', function(e){
        e.preventDefault();
        $('.sims-lp-icon-list').toggleClass('active');
    if($('.sims-lp-icon-list').hasClass('active')){
      $('.sims-lp-icon-list-btn a span').text('View Less');
    }else{
      $('.sims-lp-icon-list-btn a span').text('View More');
    }
      });

  $('.sims-lp-testimonial-slider').slick({
   slidesToShow: 3,
   slidesToScroll: 3,
   dots: true,
   arrows: true,
    adaptiveHeight: true,
    prevArrow: '<button class="slick-prev slick-arrow"><</button>',
    nextArrow: '<button class="slick-next slick-arrow">></button>',
   focusOnSelect: true,
      
  responsive: [
    {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            dots: false,
          },
        },
      ],
 });

  $('.sims-lp-tabs-list-ul li').on('click', function(e){
        e.preventDefault();
        var data_id = $(this).attr('data-id');
        $('.sims-lp-tabs-list-ul li').removeClass('active');
        $(this).addClass('active');
        $('.sims-lp-tabs-list').removeClass('active');
        $('#'+data_id).addClass('active');
    
     if($(window).width() < 767) {
       $('.sims-lp-tabs-list-main-tab-ul').slick('unslick');
      $('.sims-lp-tabs-list-main-tab-ul').slick({
  slidesToShow: 1,
  dots:false,
  arrows:false,
  centerMode: true,
  });
      }
      })
      $('.sims-lp-tabs-list-main-tab-ul li').on('click', function(e){
        e.preventDefault();
        $(this).parents('.sims-lp-tabs-list-main-tab-ul').find('li').removeClass('active');
        $(this).addClass('active');
      });
        if($(window).width() < 767) {
      $('.sims-lp-tabs-list-main-tab-ul').slick({
  slidesToShow: 1,
  dots:false,
  arrows:false,
  centerMode: true,
  });
      }


  $('.sims-lp-how-work-part').on('click', function(){
        if($(this).hasClass('active')){
          
        }else{
          $('.sims-lp-how-work-part').removeClass('active');
          $(this).addClass('active');
        }
      })

  $('.sims-lp-faq-accordion-section li').on('click', function(e){
        e.preventDefault();
        var data_id = $(this).attr('data-id');
        $('.sims-lp-faq-accordion-part').removeClass('active');
        $('#'+data_id).addClass('active');
        $('.sims-lp-faq-accordion-section li').removeClass('active');
        $(this).addClass('active');
      })
      $('.sims-lp-faq-accordion-wrap h4').on('click', function(e){
        e.preventDefault();
        if($(this).parents('.sims-lp-faq-accordion-wrap').hasClass('active')){
          $(this).parents('.sims-lp-faq-accordion-part').find('.sims-lp-faq-accordion-wrap').removeClass('active');
        }else{
          $(this).parents('.sims-lp-faq-accordion-part').find('.sims-lp-faq-accordion-wrap').removeClass('active');
          $(this).parents('.sims-lp-faq-accordion-wrap').addClass('active');
        }
      })

  $('.slider-for').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: false,
   fade: true,
    adaptiveHeight: true,
   asNavFor: '.slider-nav'
 });
 $('.slider-nav').slick({
   slidesToShow: 3,
   slidesToScroll: 1,
   asNavFor: '.slider-for',
   dots: false,
   arrows: true,
   focusOnSelect: true,
   prevArrow: '<button class="slick-prev slick-arrow"><</button>',
    nextArrow: '<button class="slick-next slick-arrow">></button>'
 });

  $('.sims-lp-tabs-list-main-tab-btn a').on('click', function(e){
    e.preventDefault();
    var data_href = $(this).attr('href');
    window.location.href = data_href;
  })

  $('nav.header__inline-menu a').on('click', function(event) {
                if (this.hash !== "") {
                    event.preventDefault();
                    var hash = this.hash;
                  console.log('iffff',hash);
                    $('html, body').animate({
                        scrollTop: $(hash).offset().top
                    }, 800, function(){
                        window.location.hash = hash;
                    });
                }
            });
  $('.product-form__submit').on('click', function(){
    setTimeout(function(){
      window.location.href = '/cart';
    }, 1500)
  })

  $('#HeaderDrawer-faq').on('click', function(){
    $('.header__icon.header__icon--menu.header__icon--summary.link.focus-inset').trigger('click');
  })

  $('.redirect_url_var').on('click', function(e){
    e.preventDefault();
    var data_url = $(this).attr('data-url');
    window.location.href = data_url;
  })

  $('#HeaderMenu-faq').on('click', function(){
    window.location.href = 'https://www.sims4home.com/#wc-main-sims-lp-faq-section';
  })

  $('#HeaderDrawer-faq').on('click', function(){
    window.location.href = 'https://www.sims4home.com/#wc-main-sims-lp-faq-section';
  })

  
  
  })

















